/**
 * Auth Gate Helper - UI-only gating logic
 * Manages when to show signup modal based on user intent
 * Does NOT change any business logic, DB, or server-side auth
 */

export interface ReturnToAction {
  path: string;
  action?: string; // e.g., 'shortlist', 'secure-unit', 'book-call', 'access-tools'
  targetPath?: string; // Target path to navigate to after auth (e.g., '/tools/calculator')
  propertyId?: string | number;
}

let returnToAction: ReturnToAction | null = null;
let gateOpenCallback: ((reason: string, action: ReturnToAction) => void) | null = null;

export const authGate = {
  /**
   * Check if user should be gated (not logged in)
   */
  shouldGate: (user: any): boolean => {
    return !user || !user.id;
  },

  /**
   * Open the gate modal with a reason and return action
   */
  openGate: (reason: string, action: ReturnToAction) => {
    returnToAction = action;
    if (gateOpenCallback) {
      gateOpenCallback(reason, action);
    }
  },

  /**
   * Get the stored return action
   */
  getReturnTo: (): ReturnToAction | null => {
    return returnToAction;
  },

  /**
   * Clear the return action after completing auth
   */
  completeGate: () => {
    const action = returnToAction;
    returnToAction = null;
    return action;
  },

  /**
   * Register callback for opening gate modal
   */
  setGateOpenCallback: (callback: ((reason: string, action: ReturnToAction) => void) | null) => {
    gateOpenCallback = callback;
  },
};
